import React, { useEffect, useState } from "react";
import { useRef } from "react";

import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { isGamesTheme } from "@utils";
import { observer } from "mobx-react";

import DataTable from "./components/DataTable";
import TimePlayedData from "./components/TimePlayedData";

export default observer(function RealityCheckPopup(props: {
	isRealityCheckActive: boolean;
}) {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

	const acceptGameResumeRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		rootStore.realityCheckStore.initializeRealityCheckPopup();
	}, []);

	const setAcceptGameResume = (): void => {
		if (
			acceptGameResumeRef != null &&
			acceptGameResumeRef.current != null
		) {
			setIsSubmitting(acceptGameResumeRef.current.checked);
		}
	};

	if (!props.isRealityCheckActive) {
		return null;
	}

	if (
		rootStore.realityCheckStore.timePlayedData == null ||
		rootStore.realityCheckStore.realityCheckData == null
	) {
		return null;
	}

	return (
		<div className="popup">
			<div className="popup__card popup__card--med">
				<div className="popup__header u-type--big">
					{t<string>("SESSION.REALITY_CHECK.REALITY_CHECK")}
				</div>
				<div className="popup__body u-gap--base">
					<TimePlayedData />

					<DataTable
						data={
							rootStore.realityCheckStore.realityCheckData
								.sportBettingOnlineInfo
						}
						isAllowed={true}
						title={"USER.WALLETS.ONLINE"}
					/>

					<DataTable
						data={
							rootStore.realityCheckStore.realityCheckData
								.sportBettingInfo
						}
						isAllowed={true}
						title={"USER.WALLETS.SHOP"}
					/>

					<DataTable
						data={
							rootStore.realityCheckStore.realityCheckData
								.casinoInfo
						}
						isAllowed={WEBPACK_IS_CASINO_ENABLED}
						title={"USER.WALLETS.CASINO"}
					/>

					<DataTable
						data={
							rootStore.realityCheckStore.realityCheckData
								.casinoLiveInfo
						}
						isAllowed={WEBPACK_IS_CASINO_LIVE_ENABLED}
						title={"USER.WALLETS.LIVE_CASINO"}
					/>

					<div className="input--check">
						<input
							ref={acceptGameResumeRef}
							onChange={() => setAcceptGameResume()}
							id="acceptGameResume"
							className="input--check__box"
							name="acceptGameResume"
							type="checkbox"
						/>
						<label
							htmlFor="acceptGameResume"
							className="input--check__label"
						>
							{t<string>(
								"SESSION.REALITY_CHECK.ACCEPT_GAME_RESUME"
							)}
						</label>
					</div>

					{isGamesTheme() && (
						<span className="u-color--text--secondary">
							{t("SESSION.REALITY_CHECK.GAMES_WARNING")}
						</span>
					)}
				</div>
				<div className="popup__footer">
					<button
						className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
						onClick={rootStore.realityCheckStore.logout}
						disabled={!isSubmitting}
					>
						{t<string>("SESSION.REALITY_CHECK.LOGOUT_BUTTON")}
					</button>
					<button
						className="popup__btn popup__btn--primary btn btn--med btn--accent"
						onClick={rootStore.realityCheckStore.resume}
						disabled={!isSubmitting}
						type="submit"
					>
						{t<string>("SESSION.REALITY_CHECK.RESUME_BUTTON")}
					</button>
				</div>
			</div>
		</div>
	);
});
